import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const PercheScegliereZappyrent = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Perché scegliere Zappyrent?
      </StyledH3>
      <TextBody>
        Attraverso il suo sistema di registrazione e accertamento dei requisiti
        richiesti per l’accesso al portale annunci,{' '}
        <strong>
          la nostra piattaforma funge da filtro e garantisce l’affidabilità,
        </strong>{' '}
        da un punto di vista personale ed economico, sia dell’inquilino che del
        proprietario di casa.{' '}
        <strong>Con Zappyrent trovi gli inquilini migliori</strong> e rimani
        sollevato dall’incombenza della gestione dei pagamenti e delle bollette,
        perché questa avviene in maniera semplificata su un unico portale,
        garantendo il tasso di occupazione dell’immobile ed entrate mensili
        fisse e certe, con rendimenti stimati intorno al 30% per affitti a 6-12
        mesi.
      </TextBody>
      <TextBody>
        Successivamente alla pubblicazione del tuo annuncio, potrai ricevere in
        tempi brevissimi una proposta di affitto: con l’addebito diretto sul
        conto dell’inquilino, non dovrai mai preoccuparti che l’inquilino non
        paghi o che la casa resti vuota.{' '}
        <strong>
          Ogni mese riceverai il canone di affitto con accredito diretto sul tuo
          conto
        </strong>{' '}
        e potrai tenere traccia di tutti i pagamenti su un’unica piattaforma.
      </TextBody>
      <TextBody>
        Rimaniamo con te per tutta la durata della locazione,{' '}
        <strong>
          e se cerchi una formula di protezione ti offriamo Protezione Zappyrent
        </strong>{' '}
        per garantirti la migliore esperienza di affitto tra privati. Siamo qui
        per te dal lunedì al venerdì per fornirti l’assistenza di cui hai
        bisogno e rispondere a tutte le tue domande. Contattaci!
      </TextBody>
    </>
  );
};

export default PercheScegliereZappyrent;
